import React, { FC } from 'react'
import { ThemeProvider } from 'styled-components'
import { merge } from 'lodash-es'
import { CardItem } from 'types'
import Card from '../Card/Card'
import { CardGroupStyle } from './CardGroupStyle'

export interface CardGroupProps {
  items: CardItem[]
  hidePrice?: boolean
  purchaseButtonText?: string
  onSelect?(id: string): void
}

/**
 * CardGroup is used to wrap all components we render in order to create each cart.
 * ThemeProvider component is used. By using the theme object we provide same styling options to all components.
 */
const CardGroup: FC<CardGroupProps> = ({
  items,
  hidePrice,
  onSelect,
  purchaseButtonText,
}) => {
  const anyHighlighted = items.some((item) => item.highlightedText)

  return (
    <CardGroupStyle anyHighlighted={anyHighlighted}>
      {items.map((item) => (
        <ThemeProvider
          key={item.id}
          theme={(theme) => {
            return merge({}, theme, {
              card: {
                backgroundColor: item.cardColor || theme.card?.backgroundColor,
              },
            })
          }}
        >
          <Card
            cardImage={item.headerImage}
            price={item.price}
            hidePrice={hidePrice}
            currency={item.currency}
            priceString={item.priceString}
            title={item.title}
            subtitle={item.subtitle}
            features={item.features}
            pricePeriod={item.pricePeriod}
            highlightedText={item.highlightedText}
            onSelect={() => (onSelect ? onSelect(item.id) : null)}
            purchaseButtonText={purchaseButtonText}
          />
        </ThemeProvider>
      ))}
    </CardGroupStyle>
  )
}

export default CardGroup
